<script setup lang="ts">
import type { MyFocusPathCode } from '#shared/area-riservata-nav';
import type { TabItem } from './types';
export type { TabItem };

const props = defineProps<{
	tabs: TabItem[];
	activeTab: MyFocusPathCode;
	tabColor: (tabId: MyFocusPathCode) => string;
}>();

const emit = defineEmits<{
	'update:activeTab': [value: MyFocusPathCode];
}>();

function selectTab(id: MyFocusPathCode) {
	emit('update:activeTab', id);
}
</script>

<template>
	<nav class="flex gap-2 border-b border-gray-200 mb-6 overflow-x-auto">
		<button
			v-for="tab in tabs"
			:key="tab.id"
			type="button"
			class="whitespace-nowrap px-4 py-2 text-xs sm:text-sm font-semibold border-b-2 transition-colors flex flex-col items-center gap-1 sm:flex-row sm:items-center"
			:class="
				activeTab === tab.id
					? ''
					: 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
			"
			:style="
				activeTab === tab.id
					? { borderBottomColor: tabColor(tab.id), color: tabColor(tab.id) }
					: undefined
			"
			@click="selectTab(tab.id)"
		>
			<span class="material-symbols-outlined text-xl sm:text-lg shrink-0" :class="{ 'fill-current': activeTab === tab.id }">
				{{ tab.icon }}
			</span>
			<span class="hidden sm:inline">{{ tab.label }}</span>
			<span class="sm:hidden mt-0.5 text-[0.7rem] tracking-wide uppercase">{{ tab.shortTitle }}</span>
		</button>
	</nav>
</template>
